import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AppLogo from "../../components/AppLogo";
import ArrowBtn from "../../components/ArrowBtn";
import { ROUTE_PATHS } from "../../constants/Router";
import { useFetchHome } from "../../hooks/useFetchHomePage";
import AppConnectErrorPanel from "./AppConnectErrorPanel";

function AppConnect() {
  const { homeData } = useSelector((state) => state.home);

  const appConnect = homeData?.appConnect || [];
  const errorApps = appConnect?.map(e => { return { appName: e.app_name, connection: e.connection_yn } })?.filter(e => e.connection === 'N');
  return (
    <div className="flex flex-col">
      <b className="text-[16px] mb-3">배달 앱 연동 현황</b>
      <div className="flex justify-between">
        <div className="flex gap-2">
          {appConnect?.map((item, index) => (
            <span key={index}>
              <AppLogo appName={item.app_type_code} />
            </span>
          ))}
        </div>

        <ArrowBtn size={16}>
          <Link to={ROUTE_PATHS.AppConnect}>
            <span className="text-appblue text-base">
              {appConnect.length} 개
            </span>
          </Link>
        </ArrowBtn>
      </div>
      {errorApps?.length > 0 ? <AppConnectErrorPanel errorApps={errorApps} /> : ''}

    </div>
  );
}

export default AppConnect;
